<div class="auth-page">
  <div class="auth-page__left">
    <div class="auth-hero">
      <p class="auth-hero__eyebrow">Melahirkan Generasi Emas</p>
      <h1 class="page-title">The Mailbox Club</h1>
      <h1 class="page-title">Indonesia</h1>
    </div>
    <div class="auth-panel">
      <app-card class="auth-card">
        <form class="auth-form" [formGroup]="form" (ngSubmit)="submit()" autocomplete="on">
          <div class="auth-form__field">
            <label for="email">Email</label>
            <input
              class="input-email"
              id="email"
              type="email"
              formControlName="email"
              placeholder="you@mailboxclubindonesia.org"
              autocomplete="email" />
            @if (form.controls.email.touched && form.controls.email.invalid) {
            <p class="auth-form__error">Please enter a valid email.</p>
            }
          </div>

          <div class="auth-form__field">
            <label for="password">Password</label>

            <div class="auth-form__password">
              <div class="auth-form__password-input">
                <input
                  class="input-password"
                  id="password"
                  [type]="isPasswordVisible() ? 'text' : 'password'"
                  formControlName="password"
                  placeholder="••••••••"
                  autocomplete="current-password" />
              </div>

              <button
                type="button"
                class="auth-form__password-toggle"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="isPasswordVisible() ? 'Hide password' : 'Show password'">
                @if (isPasswordVisible()) {
                <ng-glyph class="auth-form__password-toggle-icon" name="visibility"></ng-glyph>
                } @else {
                <ng-glyph class="auth-form__password-toggle-icon" name="visibility_off"></ng-glyph>
                }
              </button>
            </div>

            @if (form.controls.password.touched && form.controls.password.invalid) {
            <p class="auth-form__error">Password is required.</p>
            }
          </div>

          @if (authState.error()) {
          <p class="auth-form__error auth-form__error--global">{{ authState.error() }}</p>
          }

          <div class="auth-form__actions">
            <app-button type="submit" variant="primary" [disabled]="authState.loading()">
              @if (authState.loading()) { Logging in... } @else { Login }
            </app-button>
            <app-button variant="ghost" routerLink="/reset-password">Forgot password?</app-button>
          </div>
        </form>
      </app-card>
      <p class="auth-panel__message">
        This information system is the property of The Mailbox Club Indonesia and is intended solely for use by individuals who have
        been explicitly granted access privileges. By logging in, you acknowledge that all actions taken on this platform may be
        logged, monitored, reviewed, and retained for security, compliance, investigative, and operational purposes.
      </p>
    </div>
  </div>
  <div class="auth-page__right">
    <app-image-rotator class="auth-rotator" [images]="rotatorImages" />
  </div>
</div>
